// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ToolBox2-ToolBox2-module__box--X9J4l {
  height: 100%;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.src-components-ToolBox2-ToolBox2-module__box--X9J4l.src-components-ToolBox2-ToolBox2-module__page--mG4rr {
  padding: 8px 16px 0 16px;
}
.src-components-ToolBox2-ToolBox2-module__tools--G8akT {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.src-components-ToolBox2-ToolBox2-module__mainTool--xXUzd {
  flex: 1;
  min-width: 0;
}
.src-components-ToolBox2-ToolBox2-module__extraTools--dwUvz {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
  gap: 8px;
}
.src-components-ToolBox2-ToolBox2-module__content--ACorT {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
/*# sourceMappingURL=ToolBox2.module.css.map */`, "",{"version":3,"sources":["webpack://./ToolBox2.module.less","webpack://./src/components/ToolBox2/ToolBox2.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ACCF;ADCE;EACE,wBAAA;ACCJ;ADGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;ACDF;ADIA;EACE,OAAA;EACA,YAAA;ACFF;ADKA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;ACHF;ADMA;EACE,OAAA;EACA,aAAA;EACA,cAAA;ACJF;AACA,8CAA8C","sourcesContent":[".box {\n  height: 100%;\n  overflow: hidden;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n\n  &.page {\n    padding: 8px 16px 0 16px;\n  }\n}\n\n.tools {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.mainTool {\n  flex: 1;\n  min-width: 0;\n}\n\n.extraTools {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: auto;\n  gap: 8px;\n}\n\n.content {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n",".box {\n  height: 100%;\n  overflow: hidden;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n}\n.box.page {\n  padding: 8px 16px 0 16px;\n}\n.tools {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n.mainTool {\n  flex: 1;\n  min-width: 0;\n}\n.extraTools {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: auto;\n  gap: 8px;\n}\n.content {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n/*# sourceMappingURL=ToolBox2.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-ToolBox2-ToolBox2-module__box--X9J4l`;
export var page = `src-components-ToolBox2-ToolBox2-module__page--mG4rr`;
export var tools = `src-components-ToolBox2-ToolBox2-module__tools--G8akT`;
export var mainTool = `src-components-ToolBox2-ToolBox2-module__mainTool--xXUzd`;
export var extraTools = `src-components-ToolBox2-ToolBox2-module__extraTools--dwUvz`;
export var content = `src-components-ToolBox2-ToolBox2-module__content--ACorT`;
export default ___CSS_LOADER_EXPORT___;
